import { chatBotOrgId, chatBotSessionId, useApiQuery } from 'theSource/utils';
import { UserSpecificResponseDto } from './types';
import { GET_USER_SPECIFIC_DATA_QUERY_KEY } from './utils';

export interface UseUserSpecificQueryProps {
  enabled: boolean;
}

export const useUserSpecificQuery = ({
  enabled,
}: UseUserSpecificQueryProps) => {
  return useApiQuery<UserSpecificResponseDto, unknown>({
    queryKey: GET_USER_SPECIFIC_DATA_QUERY_KEY,
    endpoint: '/pwa/user_data',
    showErrorSnackbar: false,
    onSuccess: (response) => {
      if (response.data['session_id']) {
        // deleting chatbot history once user is logged in and is in new session
        if (
          localStorage.getItem('session_id') !== response.data['session_id']
        ) {
          localStorage.removeItem('chatbot_messages');
          localStorage.setItem('session_id', response.data['session_id']);
        }
        chatBotSessionId({ sessionId: response.data['session_id'] });
        chatBotOrgId({ orgId: response.data['organization_id'] });
      }
    },
    enabled,
  });
};
